import { TrustStrip, ShopGrid } from "@/components/HomeSections";
import { PageShell, usePageMeta, useJsonLd, productLd } from "@/components/PageShell";
import { PRODUCTS } from "@/data/catalog";

export default function Shop() {
  usePageMeta("Shop the jars · Dirty Paws Apothecary", "Four small-batch mushroom powders for dogs, and the Discovery Dram to try three of them.");
  useJsonLd("product-schema", PRODUCTS.map(productLd));
  return (
    <PageShell testid="shop-page">
      <ShopGrid heading="Shop the jars" as="h1" />
      <TrustStrip />
    </PageShell>
  );
}
